import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ProfileSettings } from './settings/ProfileSettings';
import { EmailDomainSettings } from './settings/EmailDomainSettings';
import { PaymentSettings } from './settings/PaymentSettings';
import { RemindersSettings } from './settings/RemindersSettings';
import { ClientPortalSettings } from './settings/ClientPortalSettings';
import { CustomFieldsSettings } from './settings/CustomFieldsSettings';
import { IntegrationSettings } from './settings/IntegrationSettings';
import { ExportImportSettings } from './settings/ExportImportSettings';
import { WalletSettings } from './settings/WalletSettings';
import { AutoReportsSettings } from './settings/AutoReportsSettings';
import { NotificationSettings } from './settings/NotificationSettings';
import { PageHero } from '../components/motion/PageHero';
import {
  UserCircle, EnvelopeSimple, CreditCard, Bell, UsersThree, ListChecks, CalendarBlank, DownloadSimple, Coins, PaperPlaneTilt, Gear} from '@phosphor-icons/react';

export function SettingsPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'super_admin' || user?.role === 'direction';
  const [activeTab, setActiveTab] = useState('profil');

  const tabs = [
    { id: 'profil', label: 'Profil', icon: UserCircle, adminOnly: false },
    { id: 'notifications', label: 'Notifications', icon: Bell, adminOnly: false },
    { id: 'emails', label: 'Emails', icon: EnvelopeSimple, adminOnly: true },
    { id: 'paiements', label: 'Paiements', icon: CreditCard, adminOnly: true },
    { id: 'relances', label: 'Relances', icon: Bell, adminOnly: true },
    { id: 'portail', label: 'Portail Client', icon: UsersThree, adminOnly: true },
    { id: 'champs', label: 'Champs', icon: ListChecks, adminOnly: false },
    { id: 'integrations', label: 'Integrations', icon: CalendarBlank, adminOnly: false },
    { id: 'export', label: 'Export/Import', icon: DownloadSimple, adminOnly: true },
    { id: 'wallet', label: 'Credits & UC', icon: Coins, adminOnly: true },
    { id: 'rapports', label: 'Rapports auto', icon: PaperPlaneTilt, adminOnly: true },
  ];

  const visibleTabs = tabs.filter(t => !t.adminOnly || isAdmin);

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Hero header — UX transversale v2 */}
      <PageHero
        title="Paramètres"
        subtitle="Configuration générale du CRM ESS — profil, notifications, intégrations"
        icon={<Gear size={24} weight="duotone" className="text-white" />}
        gradient="from-[#5E6D66] to-[#2D5A4C]"
        accents={['#80C51F', '#00AEEF']}
      />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="flex flex-wrap gap-1 h-auto bg-[#F9F8F5] p-1 rounded-lg border border-[#E8E6E1]" data-testid="settings-tabs">
          {visibleTabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className="flex items-center gap-1.5 text-xs px-3 py-2 data-[state=active]:bg-white data-[state=active]:text-[#2D5A4C] data-[state=active]:shadow-sm rounded-md"
              data-testid={`settings-tab-${tab.id}`}
            >
              <tab.icon size={14} />
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="profil" className="mt-6">
          <ProfileSettings />
        </TabsContent>

        <TabsContent value="notifications" className="mt-6">
          <NotificationSettings />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="emails" className="mt-6">
            <EmailDomainSettings />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="paiements" className="mt-6">
            <PaymentSettings />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="relances" className="mt-6">
            <RemindersSettings />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="portail" className="mt-6">
            <ClientPortalSettings />
          </TabsContent>
        )}

        <TabsContent value="champs" className="mt-6">
          <CustomFieldsSettings />
        </TabsContent>

        <TabsContent value="integrations" className="mt-6">
          <IntegrationSettings />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="export" className="mt-6">
            <ExportImportSettings />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="wallet" className="mt-6">
            <WalletSettings />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="rapports" className="mt-6">
            <AutoReportsSettings />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
